// Frozen from the current Battle Arena visible roster on 2026-09-17.
// Fight owns its tuning; Battle Arena remains identity source.
export const BATTLE_ARENA_FIGHT_ROSTER = [
  {
    "id": "iron-bulwark",
    "name": "Iron Bulwark",
    "title": "The Stalwart Defender",
    "description": "A heavily armored warrior of unyielding resilience",
    "category": "STALWART_DEFENDERS",
    "assetId": "iron-bulwark",
    "sourceModelUrl": "https://354978dcea4cd7f5e560c5d40657e77f.r2.cloudflarestorage.com/inyron/a6647be21e3a386d03aed87f9f3cc0c2acd0e4537c7363e3be93ed9f3855e283.glb",
    "runtimeModel": "iron-bulwark.glb",
    "accent": "#8B4513",
    "attack": "melee-chain",
    "special": "shockwave",
    "specialName": "Sunder",
    "ultimateName": "Sentinel's Wrath",
    "abilities": [
      "Defensive Stance",
      "Taunt",
      "Shield Bash"
    ],
    "maxHealth": 180,
    "moveSpeed": 5.2,
    "attackSpeed": 0.85,
    "damage": 35,
    "defensePower": 2200,
    "difficulty": "easy",
    "mass": 1.8
  },
  {
    "id": "plague-harbinger",
    "name": "Plague Harbinger",
    "title": "The Pestilent Bringer",
    "description": "Master of corrupting magic and disease",
    "category": "ARCANE_MASTERS",
    "assetId": "plague-harbinger",
    "sourceModelUrl": "https://354978dcea4cd7f5e560c5d40657e77f.r2.cloudflarestorage.com/inyron/eec1b9f3e25732c32d6df9283f5baadea0e2207d1cdbcfca4aa8f5e3bd5bcc00.glb",
    "runtimeModel": "plague-harbinger.glb",
    "accent": "#2F4F4F",
    "attack": "projectile",
    "special": "plague-burst",
    "specialName": "Plague Burst",
    "ultimateName": "Plague Storm",
    "abilities": [
      "Plague Cloud",
      "Curse",
      "Epidemic"
    ],
    "maxHealth": 100,
    "moveSpeed": 7.5,
    "attackSpeed": 1.2,
    "damage": 40,
    "defensePower": 950,
    "difficulty": "hard",
    "mass": 1.1
  },
  {
    "id": "echo-dancer",
    "name": "Echo Dancer",
    "title": "The Swift Striker",
    "description": "Graceful warrior with unmatched agility",
    "category": "SWIFT_STRIKERS",
    "assetId": "echo-dancer",
    "sourceModelUrl": "https://354978dcea4cd7f5e560c5d40657e77f.r2.cloudflarestorage.com/inyron/8caf1621e7e284a692822474e23a68366eb38caa3f0bc3b236d22db75c86dfeb.glb",
    "runtimeModel": "echo-dancer.glb",
    "accent": "#FF1493",
    "attack": "burst-melee",
    "special": "echo-chain",
    "specialName": "Echo Chain",
    "ultimateName": "Shatter",
    "abilities": [
      "Shadow Step",
      "Sonic Strike",
      "Echo Clone"
    ],
    "maxHealth": 90,
    "moveSpeed": 8.5,
    "attackSpeed": 1.6,
    "damage": 50,
    "defensePower": 750,
    "difficulty": "hard",
    "mass": 0.85
  },
  {
    "id": "guardian-knight",
    "name": "Guardian Knight",
    "title": "The Holy Protector",
    "description": "A shining beacon of justice and protection",
    "category": "DIVINE_WARRIORS",
    "assetId": "guardian-knight-v2",
    "sourceModelUrl": "https://354978dcea4cd7f5e560c5d40657e77f.r2.cloudflarestorage.com/inyron/cae5f40fbe93346f7f74fffda3dcc6e5aa62c957cefd3686de96ca50160d14a8.glb",
    "runtimeModel": "guardian-knight.glb",
    "accent": "#FFD700",
    "attack": "melee-chain",
    "special": "dash-strike",
    "specialName": "Dash Strike",
    "ultimateName": "Divine Bulwark",
    "abilities": [
      "Holy Strike",
      "Divine Shield",
      "Cleanse"
    ],
    "maxHealth": 140,
    "moveSpeed": 6,
    "attackSpeed": 0.95,
    "damage": 32,
    "defensePower": 1900,
    "difficulty": "medium",
    "mass": 1.6
  },
  {
    "id": "arcane-mage",
    "name": "Arcane Mage",
    "title": "The Mystical Scholar",
    "description": "Master of arcane forces and elemental magic",
    "category": "ARCANE_MASTERS",
    "assetId": "arcane-mage",
    "sourceModelUrl": "https://354978dcea4cd7f5e560c5d40657e77f.r2.cloudflarestorage.com/inyron/512937a8c85e11e32d12bc8ef7fec5648283c31b4430a7f1daac15a7adcc390d.glb",
    "runtimeModel": "derived/arcane-mage-split-v1.glb",
    "accent": "#4B0082",
    "attack": "projectile",
    "special": "phase-shift",
    "specialName": "Phase Shift",
    "ultimateName": "Arcane Rupture",
    "abilities": [
      "Fireball",
      "Ice Storm",
      "Teleport"
    ],
    "maxHealth": 80,
    "moveSpeed": 7,
    "attackSpeed": 1.3,
    "damage": 38,
    "defensePower": 700,
    "difficulty": "medium",
    "mass": 0.95
  },
  {
    "id": "cyber-vanguard",
    "name": "Cyber Vanguard",
    "title": "The Tech Pioneer",
    "description": "A warrior enhanced with advanced technology",
    "category": "TECH_WARRIORS",
    "assetId": "cyber-vanguard",
    "sourceModelUrl": "https://inyron.com/elyon/runtime-fighters/cyber-vanguard.glb",
    "runtimeModel": "cyber-vanguard.glb",
    "accent": "#00CED1",
    "attack": "melee-chain",
    "special": "blink",
    "specialName": "Blink",
    "ultimateName": "Overclock Protocol",
    "abilities": [
      "Plasma Strike",
      "Shield Generator",
      "Overcharge"
    ],
    "maxHealth": 120,
    "moveSpeed": 7.2,
    "attackSpeed": 1.25,
    "damage": 48,
    "defensePower": 1200,
    "difficulty": "medium",
    "mass": 1.3
  },
  {
    "id": "dragon-summoner",
    "name": "Dragon Summoner",
    "title": "The Dragon Lord",
    "description": "Commands the power of ancient dragons",
    "category": "SUMMONERS",
    "assetId": "dragon-summoner",
    "sourceModelUrl": "https://354978dcea4cd7f5e560c5d40657e77f.r2.cloudflarestorage.com/inyron/3ea26077e30c981e71a442ae54a213d4bd50cc98131c4031fbfcd37ad132e98e.glb",
    "runtimeModel": "dragon-summoner.glb",
    "accent": "#DC143C",
    "attack": "projectile",
    "special": "summon",
    "specialName": "Call Drake",
    "ultimateName": "Elder Wyrm",
    "abilities": [
      "Dragon Breath",
      "Summon Drake",
      "Inferno"
    ],
    "maxHealth": 110,
    "moveSpeed": 6.5,
    "attackSpeed": 1.1,
    "damage": 44,
    "defensePower": 900,
    "difficulty": "hard",
    "mass": 1.4
  },
  {
    "id": "reaper-executioner",
    "name": "Reaper Executioner",
    "title": "The Death Bringer",
    "description": "A grim warrior channeling the power of death",
    "category": "DARK_WARRIORS",
    "assetId": "reaper-executioner",
    "sourceModelUrl": "https://354978dcea4cd7f5e560c5d40657e77f.r2.cloudflarestorage.com/inyron/0d0ac51341e04e34fb01f8dee536d37d190e7f7d57ef021b03bf7af4b995f981.glb",
    "runtimeModel": "reaper-executioner.glb",
    "accent": "#000000",
    "attack": "melee-chain",
    "special": "death-mark",
    "specialName": "Death Mark",
    "ultimateName": "Harvest",
    "abilities": [
      "Death Strike",
      "Life Drain",
      "Curse of Death"
    ],
    "maxHealth": 115,
    "moveSpeed": 7.3,
    "attackSpeed": 1.35,
    "damage": 52,
    "defensePower": 850,
    "difficulty": "hard",
    "mass": 1.2
  },
  {
    "id": "revenant",
    "name": "Revenant",
    "title": "The Undead Warrior",
    "description": "Risen from death, stronger than before",
    "category": "DARK_WARRIORS",
    "assetId": "revenant",
    "sourceModelUrl": "https://inyron.com/elyon/runtime-fighters/revenant.glb",
    "runtimeModel": "revenant.glb",
    "accent": "#8B008B",
    "attack": "burst-melee",
    "special": "phase-shift",
    "specialName": "Phase Shift",
    "ultimateName": "Death Mark",
    "abilities": [
      "Undead Slam",
      "Soul Drain",
      "Resurrection"
    ],
    "maxHealth": 130,
    "moveSpeed": 6.8,
    "attackSpeed": 1.15,
    "damage": 46,
    "defensePower": 1100,
    "difficulty": "hard",
    "mass": 1.5
  },
  {
    "id": "rift-weaver",
    "name": "Rift Weaver",
    "title": "The Space Manipulator",
    "description": "Bends space and creates rifts in reality",
    "category": "ARCANE_MASTERS",
    "assetId": "rift-weaver",
    "sourceModelUrl": "https://354978dcea4cd7f5e560c5d40657e77f.r2.cloudflarestorage.com/inyron/5740bfa3ff95e1aaedb2e2bd9e4f6e8dfd0e88c48e198bc7aa30e08b080133ae.glb",
    "runtimeModel": "rift-weaver.glb",
    "accent": "#00FF00",
    "attack": "projectile",
    "special": "rift-anchor",
    "specialName": "Rift Anchor",
    "ultimateName": "Reality Fracture",
    "abilities": [
      "Rift Strike",
      "Space Warp",
      "Portal"
    ],
    "maxHealth": 100,
    "moveSpeed": 7.8,
    "attackSpeed": 1.28,
    "damage": 39,
    "defensePower": 800,
    "difficulty": "medium",
    "mass": 1
  },
  {
    "id": "tidal-warden",
    "name": "Tidal Warden",
    "title": "The Water Master",
    "description": "Guardian of the seas and water magic",
    "category": "NATURE_WARRIORS",
    "assetId": "tidal-warden",
    "sourceModelUrl": "https://354978dcea4cd7f5e560c5d40657e77f.r2.cloudflarestorage.com/inyron/205a1cf8d6aac814f7343119b552f4e5e224e6d73a8ad97c74b1de6509c124b2.glb",
    "runtimeModel": "tidal-warden.glb",
    "accent": "#1E90FF",
    "attack": "melee-chain",
    "special": "stance-shift",
    "specialName": "Stance Shift",
    "ultimateName": "Maelstrom",
    "abilities": [
      "Water Blade",
      "Tidal Wave",
      "Flood"
    ],
    "maxHealth": 150,
    "moveSpeed": 6.2,
    "attackSpeed": 0.98,
    "damage": 41,
    "defensePower": 1500,
    "difficulty": "easy",
    "mass": 1.4
  },
  {
    "id": "timekeeper",
    "name": "Timekeeper",
    "title": "The Temporal Sage",
    "description": "Harnesses the flow of time itself",
    "category": "ARCANE_MASTERS",
    "assetId": "timekeeper",
    "sourceModelUrl": "https://354978dcea4cd7f5e560c5d40657e77f.r2.cloudflarestorage.com/inyron/fc73d9f246eece106039e00b762b3de5f85a325d3dd1d683eb643f557098e796.glb",
    "runtimeModel": "timekeeper.glb",
    "accent": "#FF8C00",
    "attack": "projectile",
    "special": "time-anchor",
    "specialName": "Time Anchor",
    "ultimateName": "Chronological Collapse",
    "abilities": [
      "Chrono Bolt",
      "Time Rewind",
      "Acceleration"
    ],
    "maxHealth": 95,
    "moveSpeed": 8,
    "attackSpeed": 1.32,
    "damage": 37,
    "defensePower": 750,
    "difficulty": "medium",
    "mass": 0.9
  },
  {
    "id": "void-seraph",
    "name": "Void Seraph",
    "title": "The Cosmic Devourer",
    "description": "An entity of void energy and cosmic hunger",
    "category": "COSMIC_ENTITIES",
    "assetId": "void-seraph",
    "sourceModelUrl": "https://354978dcea4cd7f5e560c5d40657e77f.r2.cloudflarestorage.com/inyron/6318845c4aba0ae66c61cf727e578570402e97da8ad6a0d3327f8a794938def4.glb",
    "runtimeModel": "void-seraph.glb",
    "accent": "#1a0033",
    "attack": "burst-melee",
    "special": "phase-shift",
    "specialName": "Phase Shift",
    "ultimateName": "Event Horizon",
    "abilities": [
      "Void Consume",
      "Cosmic Surge",
      "Null Zone"
    ],
    "maxHealth": 105,
    "moveSpeed": 7.6,
    "attackSpeed": 1.3,
    "damage": 47,
    "defensePower": 950,
    "difficulty": "hard",
    "mass": 1.15
  },
  {
    "id": "shadow-assassin",
    "name": "Shadow Assassin",
    "title": "The Silent Killer",
    "description": "A master of stealth and shadow techniques",
    "category": "ASSASSINS",
    "assetId": "shadow-assassin",
    "sourceModelUrl": "https://inyron.com/elyon/runtime-fighters/shadow-assassin.glb",
    "runtimeModel": "shadow-assassin.glb",
    "accent": "#2F2F2F",
    "attack": "burst-melee",
    "special": "blink",
    "specialName": "Blink",
    "ultimateName": "Shadow Apocalypse",
    "abilities": [
      "Shadow Strike",
      "Poison Dart",
      "Disappear"
    ],
    "maxHealth": 85,
    "moveSpeed": 8.8,
    "attackSpeed": 1.55,
    "damage": 56,
    "defensePower": 600,
    "difficulty": "hard",
    "mass": 0.8
  },
  {
    "id": "elysama",
    "name": "Elysama",
    "title": "The Radiant Wayfinder",
    "description": "A disciplined, graceful fighter who turns precision and momentum into protection, courage, and hope.",
    "category": "BALANCED_WARRIORS",
    "assetId": "sayhuri",
    "sourceModelUrl": "https://354978dcea4cd7f5e560c5d40657e77f.r2.cloudflarestorage.com/inyron/a206c0a3723514817fd52ece5a9f4006258b6dc56b70ac0351e176f0e4fefedc.glb",
    "runtimeModel": "sayhuri.glb",
    "accent": "#FFB6C1",
    "attack": "melee-chain",
    "special": "stance",
    "specialName": "Radiant Flow",
    "ultimateName": "Elysama Radiance",
    "abilities": [
      "Luminous Strike",
      "Radiant Flow",
      "Guiding Light"
    ],
    "maxHealth": 125,
    "moveSpeed": 7.1,
    "attackSpeed": 1.2,
    "damage": 44,
    "defensePower": 1100,
    "difficulty": "medium",
    "mass": 1.25
  },
  {
    "id": "sentinel",
    "name": "Sentinel",
    "title": "The Unwavering Guardian",
    "description": "A protector who stands unmovable against all threats",
    "category": "STALWART_DEFENDERS",
    "assetId": "sentinel",
    "sourceModelUrl": "https://inyron.com/elyon/runtime-fighters/sentinel.glb",
    "runtimeModel": "sentinel.glb",
    "accent": "#A9A9A9",
    "attack": "melee-chain",
    "special": "parry-riposte",
    "specialName": "Parry Riposte",
    "ultimateName": "Earthshaker Impact",
    "abilities": [
      "Sentinel Strike",
      "Fortify",
      "Stand Ground"
    ],
    "maxHealth": 160,
    "moveSpeed": 5.5,
    "attackSpeed": 0.8,
    "damage": 38,
    "defensePower": 2000,
    "difficulty": "medium",
    "mass": 1.7
  },
  {
    "id": "sentinel-builder",
    "name": "Sentinel Builder",
    "title": "The Architect of Fortresses",
    "description": "Constructs defensive structures to protect allies",
    "category": "BUILDERS",
    "assetId": "sentinel-builder",
    "sourceModelUrl": "https://354978dcea4cd7f5e560c5d40657e77f.r2.cloudflarestorage.com/inyron/4f2bd370d04bfce619decb306335bb3860ce72e2f303e8c7e534fd34f72fe6dc.glb",
    "runtimeModel": "sentinel-builder.glb",
    "accent": "#CD853F",
    "attack": "burst-melee",
    "special": "forge-turret",
    "specialName": "Forge Turret",
    "ultimateName": "Overload Grid",
    "abilities": [
      "Build Turret",
      "Reinforce",
      "Construct"
    ],
    "maxHealth": 115,
    "moveSpeed": 6.3,
    "attackSpeed": 0.95,
    "damage": 40,
    "defensePower": 1300,
    "difficulty": "medium",
    "mass": 1.35
  },
  {
    "id": "alien-commander",
    "name": "Alien Commander",
    "title": "The Cosmic Invader",
    "description": "An extraterrestrial warrior from beyond the stars",
    "category": "ALIEN_WARRIORS",
    "assetId": "alien-commander",
    "sourceModelUrl": "https://inyron.com/elyon/runtime-fighters/alien-commander.glb",
    "runtimeModel": "alien-commander.glb",
    "accent": "#32CD32",
    "attack": "projectile",
    "special": "command",
    "specialName": "Battle Order",
    "ultimateName": "Orbital Strike",
    "abilities": [
      "Alien Tech",
      "Cosmic Ray",
      "UFO Strike"
    ],
    "maxHealth": 110,
    "moveSpeed": 7.4,
    "attackSpeed": 1.2,
    "damage": 48,
    "defensePower": 1150,
    "difficulty": "medium",
    "mass": 1.2
  },
  {
    "id": "quantum-archmage",
    "name": "Quantum Archmage",
    "title": "The Quantum Master",
    "description": "Master of quantum mechanics and probability",
    "category": "ARCANE_MASTERS",
    "assetId": "quantum-archmage",
    "sourceModelUrl": "https://inyron.com/elyon/runtime-fighters/quantum-archmage.glb",
    "runtimeModel": "quantum-archmage.glb",
    "accent": "#00BFFF",
    "attack": "projectile",
    "special": "phase-shift",
    "specialName": "Phase Shift",
    "ultimateName": "Quantum Collapse",
    "abilities": [
      "Quantum Shift",
      "Superposition",
      "Wave Collapse"
    ],
    "maxHealth": 105,
    "moveSpeed": 7.9,
    "attackSpeed": 1.25,
    "damage": 41,
    "defensePower": 900,
    "difficulty": "hard",
    "mass": 0.9
  },
  {
    "id": "wisp-warden",
    "name": "Wisp Warden",
    "title": "The Spirit Keeper",
    "description": "Keeper of ethereal spirits and soul magic",
    "category": "ETHEREAL_WARRIORS",
    "assetId": "wisp-warden",
    "sourceModelUrl": "https://354978dcea4cd7f5e560c5d40657e77f.r2.cloudflarestorage.com/inyron/4f52a97c1667f83967b78edf35cdcf9a95baf7dc5d5cfc8ede12cd52d84e3eaf.glb",
    "runtimeModel": "wisp-warden.glb",
    "accent": "#FFFACD",
    "attack": "projectile",
    "special": "swarm",
    "specialName": "Wisp Swarm",
    "ultimateName": "Wisp Tempest",
    "abilities": [
      "Spirit Summon",
      "Ethereal Bond",
      "Spectral Shield"
    ],
    "maxHealth": 90,
    "moveSpeed": 8.2,
    "attackSpeed": 1.3,
    "damage": 43,
    "defensePower": 750,
    "difficulty": "easy",
    "mass": 0.75
  },
  {
    "id": "elyon-protagonist",
    "name": "Elyon Protagonist",
    "title": "The Chosen One",
    "description": "The hero destined to save Elyon",
    "category": "LEGENDARY_CHAMPIONS",
    "assetId": "elyon-protagonist",
    "sourceModelUrl": "https://354978dcea4cd7f5e560c5d40657e77f.r2.cloudflarestorage.com/inyron/064fe3c0e8c8f357cde851a64b2819636cd69e626f6d8fc8e0957e44e5679a45.glb",
    "runtimeModel": "elyon-protagonist.glb",
    "accent": "#FFD700",
    "attack": "melee-chain",
    "special": "dash-strike",
    "specialName": "Dash Strike",
    "ultimateName": "Elyon Protagonist Apex",
    "abilities": [
      "Destiny Strike",
      "Chosen Light",
      "Ultimate Power"
    ],
    "maxHealth": 170,
    "moveSpeed": 7.2,
    "attackSpeed": 1.3,
    "damage": 52,
    "defensePower": 1300,
    "difficulty": "medium",
    "mass": 1.1
  },
  {
    "id": "jhadson-first-light",
    "name": "Jhadson First Light",
    "title": "The Radiant Sage",
    "description": "Bearer of the first light, healer and guardian",
    "category": "DIVINE_WARRIORS",
    "assetId": "jhadson-first-light",
    "sourceModelUrl": "https://354978dcea4cd7f5e560c5d40657e77f.r2.cloudflarestorage.com/inyron/1032387b24d6069bd7465fbeaf8761206546b17d3cef09b282adc9817484e5b7.glb",
    "runtimeModel": "jhadson-first-light.glb",
    "accent": "#FFA500",
    "attack": "melee-chain",
    "special": "burst",
    "specialName": "First Light Burst",
    "ultimateName": "First Light Ascension",
    "abilities": [
      "Light Strike",
      "Healing Light",
      "Radiance"
    ],
    "maxHealth": 130,
    "moveSpeed": 6.9,
    "attackSpeed": 1.05,
    "damage": 40,
    "defensePower": 1100,
    "difficulty": "medium",
    "mass": 1.15
  },
  {
    "id": "celestial-angel",
    "name": "Celestial Angel",
    "title": "The Heavenly Guardian",
    "description": "A celestial being with divine healing powers",
    "category": "DIVINE_WARRIORS",
    "assetId": "celestial-angel",
    "sourceModelUrl": "https://354978dcea4cd7f5e560c5d40657e77f.r2.cloudflarestorage.com/inyron/8274aca6153151ba00f137684403c2f0fd1c63cbc2277d6e6cdb709f533ef56d.glb",
    "runtimeModel": "celestial-angel.glb",
    "accent": "#E6E6FA",
    "attack": "melee-chain",
    "special": "heal",
    "specialName": "Mend",
    "ultimateName": "Celestial Blessing",
    "abilities": [
      "Divine Touch",
      "Healing Grace",
      "Blessing"
    ],
    "maxHealth": 115,
    "moveSpeed": 7,
    "attackSpeed": 1.1,
    "damage": 39,
    "defensePower": 1000,
    "difficulty": "easy",
    "mass": 1.05
  },
  {
    "id": "shatterkin",
    "name": "Vaeloryn, the Shatterkin",
    "title": "Crystalline bruiser - shatters outward under pressure - unyielding fragments",
    "description": "Crystalline bruiser - shatters outward under pressure - unyielding fragments",
    "category": "melee-chain",
    "assetId": "shatterkin",
    "sourceModelUrl": "https://inyron.com/elyon/runtime-fighters/shatterkin.glb",
    "runtimeModel": "shatterkin.glb",
    "accent": "#b8c4d0",
    "attack": "melee-chain",
    "special": "shockwave",
    "specialName": "Sunder",
    "ultimateName": "Vaeloryn, the Shatterkin Apex",
    "abilities": [
      "melee-chain",
      "shockwave"
    ],
    "maxHealth": 138,
    "moveSpeed": 5.4,
    "attackSpeed": 1,
    "damage": 24,
    "defensePower": 20,
    "difficulty": "medium",
    "mass": 1.6
  },
  {
    "id": "tidebound",
    "name": "Tidebound, the Mystic",
    "title": "Ethereal mystic - phases between realities - equilibrium keeper",
    "description": "Ethereal mystic - phases between realities - equilibrium keeper",
    "category": "projectile",
    "assetId": "tidebound",
    "sourceModelUrl": "https://inyron.com/elyon/runtime-fighters/tidebound.glb",
    "runtimeModel": "tidebound.glb",
    "accent": "#7ec8ff",
    "attack": "projectile",
    "special": "phase-shift",
    "specialName": "Phase Shift",
    "ultimateName": "Tidebound, the Mystic Apex",
    "abilities": [
      "projectile",
      "phase-shift"
    ],
    "maxHealth": 95,
    "moveSpeed": 6.8,
    "attackSpeed": 1,
    "damage": 28,
    "defensePower": 20,
    "difficulty": "medium",
    "mass": 0.8
  },
  {
    "id": "warden",
    "name": "Aldric Greystone",
    "title": "Balanced - wide cleave - forgiving",
    "description": "Balanced - wide cleave - forgiving",
    "category": "melee-chain",
    "assetId": "warden",
    "sourceModelUrl": "https://354978dcea4cd7f5e560c5d40657e77f.r2.cloudflarestorage.com/inyron/7eb1de404896163d5ee024e15444bfce1ad8d5bd06c3e3ae266a4146cbf0cc5c.glb",
    "runtimeModel": "warden.glb",
    "accent": "#7ec8ff",
    "attack": "melee-chain",
    "special": "dash-strike",
    "specialName": "Dash Strike",
    "ultimateName": "Radiant Ascension",
    "abilities": [
      "melee-chain",
      "dash-strike"
    ],
    "maxHealth": 100,
    "moveSpeed": 7,
    "attackSpeed": 1,
    "damage": 34,
    "defensePower": 20,
    "difficulty": "easy",
    "mass": 1
  }
] as const


export const LEGACY_FIGHT_HERO_ID_ALIASES = {
  sayuri: 'elysama',
  sayhuri: 'elysama',
} as const

export function normalizeFightHeroId(id:string):string {
  return LEGACY_FIGHT_HERO_ID_ALIASES[id as keyof typeof LEGACY_FIGHT_HERO_ID_ALIASES] ?? id
}

export type BattleArenaHeroId=(typeof BATTLE_ARENA_FIGHT_ROSTER)[number]['id']

